import type { ReactNode } from "react";

interface Props {
	plan: {
		bundleCount: number;
		stepCount: number;
		swapCount: number;
		directMatches: number;
	};
}

/**
 * `SimulationStrip` — compact "PLAN" stat row under simulation
 * results. Reads as "what's in the bundle"; cost details (USDC + gwei
 * + ETH) live in the sibling `CostBreakdown` card so the headline
 * cost number doesn't get crowded out by the plan diagnostics.
 */
export function SimulationStrip({ plan }: Props) {
	return (
		<div className="flex flex-wrap items-center gap-x-5 gap-y-1 rounded-md border border-slate-800 bg-slate-900/40 px-4 py-2 text-xs">
			<StatGroup label="Plan">
				{plan.bundleCount} bundle{plan.bundleCount === 1 ? "" : "s"}
				<Dot />
				{plan.stepCount} step{plan.stepCount === 1 ? "" : "s"}
				<Dot />
				{plan.swapCount} swap{plan.swapCount === 1 ? "" : "s"}
				<Dot />
				{plan.directMatches} direct
			</StatGroup>
		</div>
	);
}

function StatGroup({
	label,
	children,
}: {
	label: string;
	children: ReactNode;
}) {
	return (
		<span className="flex flex-wrap items-baseline gap-x-1.5">
			<span className="text-[10px] font-medium uppercase tracking-wide text-slate-500">
				{label}
			</span>
			<span className="font-mono text-slate-200">{children}</span>
		</span>
	);
}

function Dot() {
	return <span className="text-slate-600">·</span>;
}
